Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Subheader2594930777",
  {"container":"Subheader2594930777--container","standard":"Subheader2594930777--standard","neutral":"Subheader2594930777--neutral","suffix":"Subheader2594930777--suffix","root":"Subheader2594930777--root"},
  ".Subheader2594930777--container{display:flex;align-items:center;min-height:48px;justify-content:space-between;padding:11px 30px;box-sizing:border-box}.Subheader2594930777--standard{background-color:#eaf7ff;border-top:1px #c1e4fe solid;border-bottom:1px #c1e4fe solid}.Subheader2594930777--neutral{background-color:rgba(22,45,61,.03);border-top:1px #dfe5eb solid;border-bottom:1px #dfe5eb solid}.Subheader2594930777--suffix{height:0;flex-shrink:0;margin-left:12px;display:flex;align-items:center}",
  2,
  "Subheader2594930777"
);
__webpack_require__.stylable.$.register(exports.default)
